export const CHNAGE_THEME = 'CHNAGE_THEME';